/** Direction kinds */
export enum DirectionKindEnum {
  /** Incomes' direction */
  INCOME = 'INCOME',
  /** Expenses' direction */
  EXPENSE = 'EXPENSE',
  /** Income taxes' direction */
  INCOME_TAX = 'INCOME_TAX',
  /** Dividends' direction */
  DIVIDENTS = 'DIVIDENTS',
}
